export const DopeColors = {
  black: "#1e1e1e",
  white: "#f0f0f0",
  offWhite: "#dcdcdc",
  blue: "#4fa3d1",
  pink: "#ff9ff3",
  lightPink: "#ffbfff",
  green: "#3ca94b",
  darkGray: "#333",
};
